import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from 'components/Managers/Members/Context';

export default function Statistics({ data }) {
  const { state: { finchOptions } } = useContext();

  const total = data.synched + data.added - data.removed;

  return (
    <p className="mb-4 fw-light">
      {finchOptions.synchImport && (
        <>
          New Employees:
          {' '}
          <span className="fw-semibold">{data.added}</span>
          <br />

          Terminated Employees:
          {' '}
          <span className="fw-semibold">{data.removed}</span>
          <br />
        </>
      )}

      Total Number Of Employees:
      {' '}
      <span className="fw-semibold">{total > 0 ? total : 0}</span>
    </p>
  );
}

Statistics.propTypes = {
  data: PropTypes.object.isRequired,
};
